var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('iframe',{attrs:{"height":"98%","width":"99%","scrolling":"no","src":_vm.query.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }